import Vue from 'vue'
import Vuex from 'vuex'
import persistedState from 'vuex-persistedstate'
import Cookies from 'js-cookie';

Vue.use(Vuex)


import user from './modules/user'
import filter  from './modules/filter';

export default new Vuex.Store({
  modules: {
    user,
    filter
  },
  plugins: [persistedState({
      paths: ['user'], 
      storage: {
        getItem: key => Cookies.get(key),
        setItem: (key, value) => Cookies.set(key, value, { expires: 1, secure: true }),
        removeItem: key => Cookies.remove(key)
      }
  })]
})
